import React, { useState, useEffect, useRef } from "react";
import VudioContext from "./vudioContext";
import ViewService from "services/ViewService";
import { home_configuration, video_configuration } from "utils/customisation";
import { Form } from "antd";
import WidgetSvg from "assets/img/SquaresFour.svg";
import AIVideoSvg from "assets/img/Robot.svg";
import SocialMediaPostSvg from "assets/img/PaperPlaneTilt.svg";
import LivestreamSvg from "assets/img/Television.svg";
import DMAutomationSvg from "assets/img/FlowArrow.svg";
import LoadingService from "components/shared-components/Loading/LoadingServices";
import { aiOnboaringModule, automationOnboardingModule, company, livestreamOnboardingModule, sfOnboardingModule, socialMediaOnboardingModule } from "utils/vudio/vudioConstant";

function VudioProvider({ children }) {
  const [userTutorialProgressDetails, setUserTutorialProgressDetails] =
    useState(null);
  const [facebookConnectedAccounts, setFacebookConnectedAccounts] = useState(
    []
  );
  const [instagramConnectedAccounts, setInstagramConnectedAccounts] = useState(
    []
  );
  const [selectedTriggerIndex, setSelectedTriggerIndex] = useState(0);
  const [selectedResponseID, setSelectedResponseID] = useState(null);
  const [selectedConditionID, setSelectedConditionID] = useState(null);
  // Automation States
  const [triggerModal, setTriggerModal] = useState(false);
  const [sidebarStep, setSidebarStep] = useState(1);
  const [responseSidebarStep, setResponseSidebarStep] = useState(1);
  const [logicSidebarStep, setLogicSidebarStep] = useState(1);
  const [triggerAddCondition, setTriggerAddCondtion] = useState(false);
  const [applyConditions, setApplyConditions] = useState(false);
  const [sidebarCondition, setSidebarCondition] = useState("HOME");
  const [nodesUpdatedTrigger, setNodesUpdatedTrigger] = useState(true);
  const [selectedLogicNodeId, setSelectedLogicNodeID] = useState(null);
  const [selectedLogicYesNodeId, setSelectedLogicYesNodeID] = useState(null);
  const [selectedLogicNoNodeId, setSelectedLogicNoNodeID] = useState(null);
  const [selectedStepNodeID, setSelectedStepNodeId] = useState(null);
  const [isResponseOpen, setisResponseOpen] = useState(false);
  const [automationStep, setAutomationStep] = useState(
    "Please Select a Trigger"
  );
  const [openDrawer, setOpenDrawer] = useState(false);
  const [automationStepENUM, setAutomationStepENUM] = useState("TRIGGER");
  const x_request_source = localStorage.getItem("x_request_source");

  //masking states
  const maskingCanvasRef = useRef(null); // for image
  const maskingOverlayRef = useRef(null); // for mask drawing
  const maskingContainerRef = useRef(null);
  const [maskingPaths, setMaskingPaths] = useState([]);
  const [maskingBrushSize, setMaskingBrushSize] = useState(20);

  //resize canvas image states
  const resizeCanvasRef = useRef(null);
  const [resizeImageData, setResizeImageData] = useState(null);
  const [resizeImage, setResizeImage] = useState(null);
  const [resizeImageProps, setResizeImageProps] = useState({
      x: 100,
      y: 100,
      width: 200,
      height: 200,
      originalWidth: 0,
      originalHeight: 0
  });

  const resetAllResizeCanvas = ()=>{
    resizeCanvasRef.current = null;
    setResizeImage(null)
    setResizeImageData(null)
    setResizeImageProps({
      x: 100,
      y: 100,
      width: 200,
      height: 200,
      originalWidth: 0,
      originalHeight: 0
    })
  }
  const [userPermissions, setUserPermissions] = useState([]);
  const [isPermissionDetected, setIsPermissionDetected] = useState(false);

  const resetAllMasking = ()=>{
    maskingCanvasRef.current = null;
    maskingOverlayRef.current = null;
    maskingContainerRef.current = null;
    setMaskingPaths([])
    setMaskingBrushSize(20)
  }

  //TRIGGER,GREETING_MESSAGE,
  //VARIANTS_MESSAGE,
  //VARIANTS_CONDITION,
  //VARIANTS_POSTIVE_CONDITION,
  //VARIANTS_NEGATIVE_CONDITON,
  //END_CHECKOUT

  const [templateID, setTemplateID] = useState("66fab0b3195381126797d050");

  const [automationTemplates, setAutomationTemplates] = useState([]);
  const [selectedAutomationTemplate, setSelectedAutomationTemplate] =
    useState(null);

  //HOME-> Main Sidebar
  //TRIGGER
  //RESPONSE
  //LOGIC

  const [triggerData, setTriggerData] = useState([
    {
      automatePosts: "",
      keywordSelection: "",
      platform: "instagram",
      triggerEvent: "",
      specificKewords: [],
      predefinedKeyWords: [],
      // Resposne Dummy Object
      // {
      //   responseID:"",
      //   responseStep: "",
      //   responseDelay: 2,
      //   responseMessage: "",
      //   responseCondition: "",
      //   responseButtons:[]
      //  responseType:""
      // },
      response: [],

      // Conditions Dummy Object
      // {
      //   conditionID:"",
      //   conditionStep: "",
      //   conditionMessage: "",
      //   onconditionSuccess: "",
      //   onconditionFailure: "",
      //   conditionKeywords:[]
      // },
      conditions: [],
    },
  ]);

  const selectedConditionNode = triggerData[
    selectedTriggerIndex
  ]?.conditions.find((res) => res.conditionID == selectedConditionID);

  const fetchAutomationTemplates = async (platform, type) => {
    try {
      const response = await ViewService.getAutomationTemplates(platform, type);
      if (response?.message == "Success") {
        setAutomationTemplates(response?.data);
        setSelectedAutomationTemplate(response?.data[0]);
      }
    } catch (err) {
      console.error(err);
    }
  };

  function getPostAutomationId(sequences, sequenceName, variantValue) {
    const sequence = sequences.find(
      (seq) => seq.sequence_name === sequenceName
    );

    if (sequence && sequence.response) {
      const response = sequence.response.find(
        (res) => res.value === variantValue
      );
      return response ? response.post_automation_template_id : null;
    }

    return sequence ? sequence.post_automation_template_id : null;
  }

  const cleanValue = (htmlString) => {
    return htmlString
      .replace(/<[^>]*>/g, "")
      .replace(/\s+/g, " ")
      .trim();
  };

  function getResponseMessage(responses, responseType) {
    const response = responses.find((res) => res.responseType === responseType);

    let formattedMessage = "";

    if (responseType == "variant_selection_success") {
      const messages = response ? response?.responseMessages : null;

      if (messages) {
        const cleanedData = messages.map((item) => ({
          ...item,
          value: cleanValue(item.value),
        }));
        formattedMessage = cleanedData;
      }
    } else if (responseType == "variant_selection_success") {
      const messages = response ? response?.responseMessages : null;
      if (messages) {
        const cleanedData = messages.map((item) => ({
          ...item,
          value: cleanValue(item.value),
        }));
        formattedMessage = cleanedData;
      }
    } else {
      formattedMessage = response
        ? response?.responseMessage?.replace(/<[^>]*>/g, "")
        : "";
    }

    return formattedMessage;
  }

  const formatMessageWithVariables = (message) => {
    // Use a regular expression to find all <span> elements and replace their content with {{Content}}
    return message.replace(
      /<span[^>]*>(.*?)<\/span>/g,
      (match, p1) => `{{${p1}}}`
    );
  };

  const handleChange = (field, value, index, responseId) => {
    setTriggerData((prevState) => {
      const newState = [...prevState];

      // Function to update responses
      const updateResponse = (id, updatedField, updatedValue) => {
        const newResponse = newState[index].response.map((response) =>
          response.responseID === id
            ? { ...response, [updatedField]: updatedValue }
            : response
        );
        newState[index].response = newResponse;
      };

      // Function to update conditions
      const updateCondition = (conditionId, updatedField, updatedValue) => {
        const newCondition = newState[index].conditions.map((condition) =>
          condition.conditionID === conditionId
            ? { ...condition, [updatedField]: updatedValue }
            : condition
        );
        newState[index].conditions = newCondition;
      };

      const updateResponseMessages = (responseId, message) => {
        const newResponse = newState[index].response.map((response) =>
          response.responseID === responseId
            ? {
                ...response,
                responseMessages: response.responseMessages
                  .map((msg) =>
                    msg.id === message.id
                      ? { ...msg, value: message.value }
                      : msg
                  )
                  .concat(
                    !response.responseMessages.some(
                      (msg) => msg.id === message.id
                    )
                      ? [message]
                      : []
                  ),
              }
            : response
        );
        newState[index].response = newResponse;
      };

      if (responseId !== undefined) {
        if (field === "responseMessages") {
          updateResponseMessages(responseId, value);
        } else if (field.includes("response")) {
          updateResponse(responseId, field, value);
        } else if (field.includes("condition")) {
          updateCondition(responseId, field, value);
        }
      } else {
        // Handle adding new response or condition
        if (field === "response") {
          const newResponseArray = [...newState[index].response, { ...value }];
          newState[index].response = newResponseArray;
        } else if (field === "conditions") {
          const newConditionArray = [
            ...newState[index].conditions,
            { ...value },
          ];
          newState[index].conditions = newConditionArray;
        } else {
          newState[index] = {
            ...newState[index],
            [field]: value,
          };
        }
      }

      return newState;
    });
  };

  const initialNodes = [
    {
      id: `start_0`,
      type: "startNode",
      position: { x: 100, y: 320 },
      data: { id: `start_0` },
    },

    {
      id: `ini_0`,
      type: "whenInitialNode",
      position: { x: 270, y: 200 },
      data: { id: `ini_0` },
    },
    {
      id: `sel_ini_0_1`,
      type: "selectNode",
      position: { x: 630, y: 200 },
      data: { id: `sel_ini_0_1` },
    },
  ];

  const initialEdges = [
    {
      id: "e1-1",
      source: "start_0",
      target: "ini_0",
      style: { stroke: "#B5B5B5", strokeWidth: 2 },
    },
    {
      id: "e1-2",
      source: "ini_0",
      target: "sel_ini_0_1",
      style: { stroke: "#B5B5B5", strokeWidth: 2 },
    },
  ];

  const [nodes, setNodes] = useState(initialNodes);
  const [edges, setEdges] = useState(initialEdges);
  const [isAddNodesModalOpen, setAddNodesModalOpen] = useState(false);

  useEffect(() => {
    setNodesUpdatedTrigger((prev) => !prev);
  }, []);

  const quillRef = useRef(null);

  const findNodeByID = (existingNodeId, nodes) => {
    const existingNode = nodes.find((node) => node.id === existingNodeId);

    return existingNode ? existingNode : false;
  };

  const attachNodeById = (nodes, edges, newNode, existingNodeId, pathType) => {
    const existingNode = nodes.find((node) => node.id === existingNodeId);

    if (!existingNode) {
      console.error("Existing node not found.");
      return { nodes, edges };
    }

    console.log("Attaching new node to existing node:", existingNodeId);

    if (pathType !== undefined) {
      const updatedNodes = [...nodes, newNode];

      const edgeStyle =
        pathType === "yes"
          ? { stroke: "#B5B5B5", strokeWidth: 2 }
          : { stroke: "#B5B5B5", strokeWidth: 2 };
      const sourceHandle = pathType === "yes" ? "yes" : "no";
      const nodeLabel = pathType === "yes" ? "True" : "False";

      const updatedEdges = [
        ...edges,
        {
          id: `e-${newNode.id}-from-logic`,
          source: existingNodeId,
          sourceHandle: sourceHandle,
          target: newNode.id,
          style: edgeStyle,
          label: nodeLabel,
          labelStyle: { fill: "white", fontWeight: "bold", fontSize: 10 },
          labelBgStyle: { fill: "#4C4C4C", rx: 5, ry: 5 },
          labelBgPadding: [20, 10],
        },
      ];

      return { nodes: updatedNodes, edges: updatedEdges };
    } else {
      const updatedNodes = [...nodes, newNode];

      const updatedEdges = edges.concat([
        {
          id: `e-${existingNodeId}-to-${newNode.id}`,
          source: existingNodeId,
          target: newNode.id,
          style: { stroke: "#B5B5B5", strokeWidth: 2 },
        },
      ]);
      return { nodes: updatedNodes, edges: updatedEdges };
    }
  };

  const handleAddCondition = (currentNodeID) => {
    setTriggerAddCondtion(true);
    setLogicSidebarStep(2);

    const conditionObj = {
      conditionID: triggerData[selectedTriggerIndex].conditions.length,
      conditionStep: triggerData[selectedTriggerIndex].conditions.length + 1,
      conditionMessage: "Variants",
      onconditionSuccess: null,
      onconditionFailure: null,
      conditionKeywords: [],
    };

    handleChange("conditions", conditionObj, selectedTriggerIndex);

    //Getting Previous Node id to attach
    const currentLogicNode = findNodeByID(currentNodeID, nodes);

    const newYesNodeID = generateNodeId(
      "logicYesNode",
      currentNodeID,
      nodes.length
    );

    const newNoNodeID = generateNodeId(
      "logicNoNode",
      currentNodeID,
      nodes.length
    );

    setSelectedLogicYesNodeID(newYesNodeID);
    setSelectedLogicNoNodeID(newNoNodeID);

    const onYesNode = {
      id: newYesNodeID,
      type: "selectNode",
      position: {
        x: currentLogicNode.position["x"] + 400,
        y: currentLogicNode.position["y"] - 300,
      },
      data: { id: newYesNodeID },
    };

    const onNoNode = {
      id: newNoNodeID,
      type: "selectNode",
      position: {
        x: currentLogicNode.position["x"] + 400,
        y: currentLogicNode.position["y"] + 200,
      },
      data: { id: newNoNodeID },
    };

    const { nodes: updatedNodesYes, edges: updatedEdgesYes } = attachNodeById(
      nodes,
      edges,
      onYesNode,
      currentNodeID,
      "yes"
    );

    // Add No Node and create edge from LogicNode to No Node
    const { nodes: updatedNodesNo, edges: updatedEdgesNo } = attachNodeById(
      updatedNodesYes,
      updatedEdgesYes,
      onNoNode,
      currentNodeID,
      "no"
    );

    setNodes(updatedNodesNo);
    setEdges(updatedEdgesNo);
  };

  const removeNode = (nodes, edges, nodeId) => {
    // Filter out the node to be removed
    const updatedNodes = nodes.filter((node) => node.id !== nodeId);

    // Update the edges by filtering out those connected to the removed node
    const updatedEdges = edges.filter(
      (edge) => edge.source !== nodeId && edge.target !== nodeId
    );

    // Additionally, if you want to remove any edges that were connected to the removed node,
    // you can create a new edge connecting the previous node to the next node if necessary.

    const newEdges = [];

    // Find edges to potentially reconnect
    updatedEdges.forEach((edge) => {
      if (edge.source === nodeId) {
        const targetNode = updatedNodes.find((node) => node.id === edge.target);
        if (targetNode) {
          const previousNode = updatedNodes.find(
            (node) => node.id === edge.source
          );
          if (previousNode) {
            newEdges.push({
              id: `e-${previousNode.id}-${targetNode.id}`,
              source: previousNode.id,
              target: targetNode.id,
              style: { stroke: "#B5B5B5", strokeWidth: 2 },
            });
          }
        }
      } else if (edge.target === nodeId) {
        const sourceNode = updatedNodes.find((node) => node.id === edge.source);
        const nextNode = updatedNodes.find((node) => node.id === edge.target);
        if (sourceNode && nextNode) {
          newEdges.push({
            id: `e-${sourceNode.id}-${nextNode.id}`,
            source: sourceNode.id,
            target: nextNode.id,
            style: { stroke: "#B5B5B5", strokeWidth: 2 },
          });
        }
      }
    });

    return { nodes: updatedNodes, edges: [...newEdges, ...updatedEdges] };
  };

  const getFormattedMessage = (message) => {
    const formattedMessage = message ? message.replace(/<[^>]*>/g, "") : "";

    const formattedWithSpans = formattedMessage.replace(
      /{{(.*?)}}/g,
      (match, p1) => {
        const span = document.createElement("span");
        span.setAttribute("contenteditable", false);
        span.style.display = "inline-flex";
        span.style.padding = "2px";
        span.style.justifyContent = "center";
        span.style.alignItems = "center";
        span.style.gap = "8px";
        span.style.border = "none";
        span.style.color = "#329C00";
        span.style.marginLeft = "2px";
        span.style.marginRight = "2px";
        span.innerText = `{{${p1}}}`;

        return span.outerHTML;
      }
    );

    return `<span>${formattedWithSpans}</span>`;
  };

  const generateNodeId = (type, previousNodeId, index) => {
    const typeMap = {
      selectNode: "sel",
      startNode: "start",
      whenInitialNode: "ini",
      responseNode: "res",
      logicNode: "log",
      logicYesNode: "log_yes",
      logicNoNode: "log_no",
      endNode: "end",
    };

    const typeCode = typeMap[type] || "unknown";
    return `${typeCode}_${previousNodeId}_${index}`;
  };

  const getPreviousNodeIdFromEdges = (currentNodeId) => {
    const edge = edges.find((edge) => edge.target === currentNodeId);
    return edge ? edge.source : null;
  };

  const getNextNodeIdFromEdges = (currentNodeId) => {
    const edge = edges.find((edge) => edge.source === currentNodeId);
    return edge ? edge.target : null;
  };

  const handleContentClick = (nodeId, position = "default") => {
    if (position == "modal") {
      setAddNodesModalOpen(false);
    }

    const responseType = nodeId.includes("log_yes")
      ? "variant_selection_success"
      : nodeId.includes("log_no")
      ? "variant_selection_failure"
      : nodeId == "sel_ini_0_1"
      ? "greeting"
      : "";

    const responseObject =
      responseType == "variant_selection_success"
        ? {
            responseID: triggerData[selectedTriggerIndex].response.length,
            responseStep: triggerData[selectedTriggerIndex].response.length + 1,
            responseDelay: 2,
            responseMessages: [
              {
                id: "Greeting",
                value: getFormattedMessage(`<span>
                    Hi {{UserName}}, thanks for your interest in
                    {{ProductName}}
                  </span>`),
              },
              {
                id: "VariantsSelection",
                value: getFormattedMessage(`<span>
                Great choice! Now, what {{VariantType}} do you want? Please choose a variant:
            </span>`),
              },
              {
                id: "Checkout",
                value: getFormattedMessage(`<span>
                Hi {{UserName}}, thanks for your interest in {{ProductName}}
            </span>`),
              },
            ],
            responseCondition: "",
            responseButtons: [],
            responseType: responseType,
          }
        : responseType == "variant_selection_failure"
        ? {
            responseID: triggerData[selectedTriggerIndex].response.length,
            responseStep: triggerData[selectedTriggerIndex].response.length + 1,
            responseDelay: 2,
            responseMessages: [
              {
                id: "Checkout",
                value: getFormattedMessage(`<span>
              Hi {{UserName}}, thanks for your interest in {{ProductName}}
          </span>`),
              },
            ],
            responseCondition: "",
            responseButtons: [],
            responseType: responseType,
          }
        : {
            responseID: triggerData[selectedTriggerIndex].response.length,
            responseStep: triggerData[selectedTriggerIndex].response.length + 1,
            responseDelay: 2,
            responseMessage: "",
            responseCondition: "",
            responseButtons: [],
            responseType: responseType,
          };

    //Getting Previous Node id to attach

    const previousNodeID = getPreviousNodeIdFromEdges(nodeId);

    const previousNode = findNodeByID(previousNodeID, nodes);

    const { nodes: updatedNodes, edges: updatedEdges } = removeNode(
      nodes,
      edges,
      nodeId
    );

    const newResponseNodeID = generateNodeId(
      "responseNode",
      previousNode?.id,
      updatedNodes.length
    );

    const newNode = {
      id: newResponseNodeID,
      type: "responseNode",
      position: {
        x: previousNode.position["x"] + 400,
        y: previousNode.position["y"] + 100,
      },
      data: {
        id: triggerData[selectedTriggerIndex].response.length,
        nodeId: newResponseNodeID,
      },
    };

    handleChange("response", responseObject, selectedTriggerIndex);

    //For Yes Node dege
    if (nodeId.includes("log_yes")) {
      setAutomationStep("Enter Condtion Success Response");
      setAutomationStepENUM("VARIANTS_POSITIVE_CONDITION");
      handleChange(
        "onconditionSuccess",
        {
          type: "triggerResponse",
          id: newResponseNodeID,
        },
        selectedTriggerIndex,
        selectedConditionID
      );
      const newYesNode = {
        ...newNode,
        position: {
          x: previousNode.position["x"] + 400,
          y: previousNode.position["y"] - 300,
        },
      };

      const { nodes: updatedNodes2, edges: updatedEdges2 } = attachNodeById(
        updatedNodes,
        updatedEdges,
        newYesNode,
        previousNodeID,
        "yes"
      );

      //Getting Previous Node id of just inserted Response node id

      const previousResponseNode = findNodeByID(
        newResponseNodeID,
        updatedNodes2
      );

      const newStepNodeID = generateNodeId(
        "responseNode",
        previousResponseNode?.id,
        updatedNodes2.length
      );

      const newstepNode = {
        id: newStepNodeID,
        type: "selectNode",
        position: {
          x: previousResponseNode.position["x"] + 350,
          y: previousResponseNode.position["y"] + 100,
        },
        data: { id: newStepNodeID },
      };
      setSelectedStepNodeId(newStepNodeID);

      const { nodes: updatedNodes3, edges: updatedEdges3 } = attachNodeById(
        updatedNodes2,
        updatedEdges2,
        newstepNode,
        newResponseNodeID
      );

      setNodes(updatedNodes3);
      setEdges(updatedEdges3);
    } else if (nodeId.includes("log_no")) {
      setAutomationStep("Enter Condtion Failed Response");
      setAutomationStepENUM("VARIANTS_NEGATIVE_CONDITION");
      const newYesNode = {
        ...newNode,
        position: {
          x: previousNode.position["x"] + 400,
          y: previousNode.position["y"] + 200,
        },
      };

      handleChange(
        "onconditionFailure",
        {
          type: "triggerResponse",
          id: newResponseNodeID,
        },
        selectedTriggerIndex,
        selectedConditionID
      );

      const { nodes: updatedNodes2, edges: updatedEdges2 } = attachNodeById(
        updatedNodes,
        updatedEdges,
        newYesNode,
        previousNodeID,
        "no"
      );

      //Getting Previous Node id of just inserted Response node id

      const previousResponseNode = findNodeByID(
        newResponseNodeID,
        updatedNodes2
      );

      const newStepNodeID = generateNodeId(
        "responseNode",
        previousResponseNode?.id,
        updatedNodes2.length
      );

      const newstepNode = {
        id: newStepNodeID,
        type: "selectNode",
        position: {
          x: previousResponseNode.position["x"] + 350,
          y: previousResponseNode.position["y"] + 100,
        },
        data: { id: newStepNodeID },
      };

      setSelectedStepNodeId(newStepNodeID);

      const { nodes: updatedNodes3, edges: updatedEdges3 } = attachNodeById(
        updatedNodes2,
        updatedEdges2,
        newstepNode,
        newResponseNodeID
      );

      setNodes(updatedNodes3);
      setEdges(updatedEdges3);
    } else {
      const { nodes: updatedNodes1, edges: updatedEdges1 } = attachNodeById(
        updatedNodes,
        updatedEdges,
        newNode,
        previousNodeID
      );

      const previousResponseNode = findNodeByID(
        newResponseNodeID,
        updatedNodes1
      );

      const newStepNodeID = generateNodeId(
        "responseNode",
        newResponseNodeID,
        updatedNodes1.length
      );

      const newstepNode = {
        id: newStepNodeID,
        type: "selectNode",
        position: {
          x: previousResponseNode.position["x"] + 350,
          y: previousResponseNode.position["y"] + 100,
        },
        data: { id: newStepNodeID },
      };
      setSelectedStepNodeId(newStepNodeID);

      const { nodes: updatedNodes2, edges: updatedEdges2 } = attachNodeById(
        updatedNodes1,
        updatedEdges1,
        newstepNode,
        newResponseNodeID
      );

      setNodes(updatedNodes2);
      setEdges(updatedEdges2);

      if (automationStepENUM == "TRIGGER") {
        setAutomationStep("Please Enter a Greeting Response");
        setAutomationStepENUM("GREETING");
      }
    }

    setSidebarCondition("RESPONSE");
    setisResponseOpen(true);
    setResponseSidebarStep(2);
    setOpenDrawer(true);
  };

  const handleLogicClick = (nodeId, position = "default") => {
    if (position == "modal") {
      setAddNodesModalOpen(false);
    }
    setSidebarCondition("LOGIC");
    setLogicSidebarStep(1);

    //Getting Previous Node id to attach
    const previousNodeID = getPreviousNodeIdFromEdges(nodeId);
    const previousNode = findNodeByID(previousNodeID, nodes);

    //Removing existing select node
    const { nodes: updatedNodes, edges: updatedEdges } = removeNode(
      nodes,
      edges,
      nodeId
    );

    const newLoginNodeID = generateNodeId(
      "logicNode",
      previousNode?.id,
      updatedNodes.length
    );
    setSelectedLogicNodeID(newLoginNodeID);

    const newNode = {
      id: newLoginNodeID,
      type: "logicNode",
      position: {
        x: previousNode.position["x"] + 350,
        y: previousNode.position["y"] + 0,
      },
      data: {
        id: newLoginNodeID,
        logicID: triggerData[selectedTriggerIndex].conditions.length,
      },
    };

    //Inserting new Logic Node
    const { nodes: updatedNodes2, edges: updatedEdges2 } = attachNodeById(
      updatedNodes,
      updatedEdges,
      newNode,
      previousNodeID
    );

    if (nodeId.includes("log_yes")) {
      handleChange(
        "onconditionSuccess",
        {
          type: "logic",
          id: newLoginNodeID,
        },
        selectedTriggerIndex,
        selectedConditionID
      );
    } else if (nodeId.includes("log_no")) {
      handleChange(
        "onconditionFailure",
        {
          type: "logic",
          id: newLoginNodeID,
        },
        selectedTriggerIndex,
        selectedConditionID
      );
    }

    if (
      automationStepENUM == "VARIANTS_MESSAGE" ||
      automationStepENUM == "GREETING"
    ) {
      setAutomationStep("Please select the condition");
      setAutomationStepENUM("VARIANTS_CONDITION");
      // setTemplateID("66fab0d2195381126797d052");
    }

    setisResponseOpen(true);
    setResponseSidebarStep(2);
    setNodes(updatedNodes2);
    setEdges(updatedEdges2);
  };

  const handleSelectRemoveNode = (nodeId, position = "default") => {
    if (position == "modal") {
      setAddNodesModalOpen(false);
    }
    if (nodeId.includes("log_yes")) {
      handleChange(
        "onconditionSuccess",
        {
          type: "END",
          id: "",
        },
        selectedTriggerIndex,
        selectedConditionID
      );
    } else if (nodeId.includes("log_no")) {
      handleChange(
        "onconditionFailure",
        {
          type: "END",
          id: "",
        },
        selectedTriggerIndex,
        selectedConditionID
      );
    }

    const previousNodeID = getPreviousNodeIdFromEdges(nodeId);
    const previousNode = findNodeByID(previousNodeID, nodes);

    const { nodes: updatedNodes, edges: updatedEdges } = removeNode(
      nodes,
      edges,
      nodeId
    );

    // const responseObject = {
    //   responseID: triggerData[selectedTriggerIndex].response.length,
    //   responseStep: triggerData[selectedTriggerIndex].response.length + 1,
    //   responseDelay: 2,
    //   responseMessage: "",
    //   responseCondition: "",
    //   responseButtons: [
    //     {
    //       type: "Checkout",
    //       link: "",
    //     },
    //   ],
    //   responseType: "checkout_link",
    // };

    const newResponseNodeID = generateNodeId(
      "endNode",
      previousNodeID,
      updatedNodes.length
    );

    const newNode = {
      id: newResponseNodeID,
      type: "endNode",
      position: {
        x: previousNode.position["x"] + 300,
        y: previousNode.position["y"] + 200,
      },
      data: {
        id: newResponseNodeID,
      },
    };

    // handleChange("response", responseObject, selectedTriggerIndex);

    const { nodes: updatedNodes1, edges: updatedEdges1 } = attachNodeById(
      updatedNodes,
      updatedEdges,
      newNode,
      previousNodeID
    );

    setNodes(updatedNodes1);
    setEdges(updatedEdges1);

    setSidebarCondition("RESPONSE");
    setisResponseOpen(true);
    setResponseSidebarStep(2);
    if (newNode.type !== "endNode") {
      setOpenDrawer(true);
    }

    if (
      selectedConditionNode?.onconditionSuccess != null &&
      selectedConditionNode?.onconditionFailure != null
    ) {
      setAutomationStep("Enter Checkout Message");
      setAutomationStepENUM("END");
      // setTemplateID("66fab0ee195381126797d054");
    }
  };

  const handleDeleteNode = (nodeId) => {
    const previousNodeID = getPreviousNodeIdFromEdges(nodeId);
    const nextNodeID = getNextNodeIdFromEdges(nodeId);

    const { nodes: updatedNodes, edges: updatedEdges } = removeNode(
      nodes,
      edges,
      nodeId
    );

    if (previousNodeID && nextNodeID) {
      updatedEdges.push({
        id: `edge-${previousNodeID}-${nextNodeID}`,
        source: previousNodeID,
        target: nextNodeID,
      });
    }

    setNodes(updatedNodes);
    setEdges(updatedEdges);
  };

  const handleExit = () => {
    setNodes(initialNodes);
    setEdges(initialEdges);
    setTriggerData([
      {
        automatePosts: "allPosts",
        keywordSelection: "all",
        platform: "facebook",
        triggerEvent: "",
        specificKewords: [],
        predefinedKeyWords: [],
        response: [],
        conditions: [],
      },
    ]);
    setSidebarStep(1);
    setAutomationStepENUM("TRIGGER");
    setSidebarCondition("HOME");
  };

  //Customizations

  //Banner
  const [bannerConfiguration, setBannerConfiguration] = useState({
    bannerRadius: 0,
    showMuteUnmute: true,
    ctaConfiguration: {
      display: true,
      text: "Shop Now",
      style: {
        fontColor: "#000000",
        fontWeight: 700,
        fontSize: 18,
        backgroundColor: "#000000",
        buttonColor: "#ffffff",
        borderRadius: 8,
      },
    },
    titleConfiguration: {
      display: false,
      text: "Default Title",
      style: {
        fontColor: "#ffffff",
        fontWeight: 700,
      },
    },
    descriptionConfiguration: {
      display: false,
      text: "Default Description",
      style: {
        fontColor: "#ffffff",
        fontWeight: 400,
      },
    },
    placement: "bottom-center",
    mobile_aspect_ratio: "16:9"
  });

  //HomePage-PIP

  const [pipHomepageCustomisation, setPipHomepageCustomisation] = useState({
    redirect: "1",
    pipPlacement: "right",
    size: {
      desktop: {
        height: "230px",
        width: "130px",
      },
      mobile: {
        height: "150px",
        width: "90px",
      },
    },
  });

  const [pipVideoCustomisation, setPipVideoCustomisation] =
    useState(video_configuration);
  //Sticky ATC
  const [atcConfiguration, setAtcConfiguration] = useState({
    cta: {
      text: "Add to cart",
      backgroud_color: "#000000",
      text_color: "#ffffff",
      font_weight: 600,
    },
    product_name: {
      text_color: "#000000",
      font_weight: 600,
    },
    product_price: {
      selling_price: {
        text_color: "#000000",
        font_weight: 600,
      },
      original_price: {
        text_color: "#929292",
        font_weight: 600,
      },
      discount_tag: {
        text_color: "#ffffff",
        font_weight: 400,
        backgroud_color: "#00b528",
      },
      price_prefix: "INR",
    },
  });
  const [showToast, setShowToast] = useState(false);
  const [toastCount, setToastCount] = useState(0);
  const [toastArray, setToastArray] = useState([]);
  const comapnyId = localStorage.getItem("companyId");
  const enableSocialMediaModule = ["e4931d5554"];

  const handleScope = async () => {
    try {
      const parsedData = JSON.parse(localStorage.getItem("scope"));
      return Array.isArray(parsedData);
    } catch (error) {
      return false;
    }
  };

  const getOnboardingData = async (companyId)=>{
    if(localStorage.getItem("redirectedCms") == "true" || localStorage.getItem("x_request_source")== "APPSUMO"){
      if(enableSocialMediaModule.includes(companyId)){
        return {
          video_widget: sfOnboardingModule,
          social_media_post: socialMediaOnboardingModule
        }
      }
      else{
        return {
          video_widget: sfOnboardingModule
        }
      }
    }
    else{
      const hasScope = await handleScope();
      if(hasScope){
        const parsedDataScope = JSON.parse(localStorage.getItem("scope"));
        if (parsedDataScope.includes("*")) {
          return {
            video_widget: sfOnboardingModule,
            ai_video: aiOnboaringModule,
            social_media_post: socialMediaOnboardingModule,
            livestream: livestreamOnboardingModule,
            dm_automation: automationOnboardingModule
          }
        } else {
          let newConfig = {};
          let isSfIncluded = false;
          if(parsedDataScope.includes("shoppable_feed")){
            newConfig["video_widget"]= sfOnboardingModule;
            isSfIncluded = true
          }
          if(parsedDataScope.includes("story") && !isSfIncluded){
            newConfig["video_widget"]= sfOnboardingModule;
          }
          if(parsedDataScope.includes("ai_studio")){
            newConfig["ai_video"]= aiOnboaringModule;
          }
          if(parsedDataScope.includes("social_media")){
            newConfig["social_media_post"]= socialMediaOnboardingModule;
          }
          if(parsedDataScope.includes("live_stream")){
            newConfig["livestream"]= livestreamOnboardingModule;
          }
          newConfig["dm_automation"] = automationOnboardingModule;
          return newConfig;
        }
      }
      else{
        return {
          video_widget: sfOnboardingModule,
          ai_video: aiOnboaringModule,
          social_media_post: socialMediaOnboardingModule,
          livestream: livestreamOnboardingModule,
          dm_automation: automationOnboardingModule
        }
      }
    }
  }

  const isRedirectedFromLively =
    localStorage.getItem("redirectedCms") == "true" ||
    x_request_source == "APPSUMO";

  const [onboardingTutorial, setOnboardingTutorial] = useState({});

  const fetchOnboarding = async (companyId) => {
      const data = await getOnboardingData(companyId);
      setOnboardingTutorial(data);
  };

  const resetContext = () => {
    const companyId = localStorage.getItem("companyId");
    fetchOnboarding(company.getCompanyId())
    setUserTutorialProgressDetails(null)
    setIsFirstTimeUser(false);
  };

  const updateTutorialModule = (moduleName, updatedData) => {
    setOnboardingTutorial((prevState) => ({
      ...prevState,
      [moduleName]: {
        ...prevState[moduleName],
        ...updatedData,
      },
    }));
  };

  const handleUpdateTutorialProgress = (moduleName, newProgress) => {
    updateTutorialModule(moduleName, { progress: newProgress });
  };

  const handleUpdateTutorialActiveState = (moduleName, isActive) => {
    updateTutorialModule(moduleName, { isActive: isActive });
  };

  const handleToastData = (toastObj) => {
    setShowToast(toastObj?.display);
    const givenToastArray = toastObj?.message;
    let newToastArray = [];
    if (Array.isArray(givenToastArray)) {
      for (let i = 0; i < givenToastArray.length; i++) {
        newToastArray.push(givenToastArray[i]);
      }
      for (let j = givenToastArray.length; j < 5; j++) {
        newToastArray.push(null);
      }
      setToastCount(givenToastArray.length);
      setToastArray([...newToastArray]);
    }
    for (let j = 0; j < 5; j++) {
      newToastArray.push(null);
    }

    setToastCount(0);
    setToastArray([...newToastArray]);
  };

  const handleToastArray = (value, index) => {
    let currentToastArray = [...toastArray];
    currentToastArray[index] = value;
    setToastArray([...currentToastArray]);
  };

  //carousel

  const [homepageConfiguration, setHomePageConfiguration] =
    useState(home_configuration);
  const [videoPageConfiguration, setVideoPageConfiguration] =
    useState(video_configuration);
  const [videoConfig] = Form.useForm();
  const [homepageConfig] = Form.useForm();

  //collection
  const [plpConfigurations, setPlpConfigurations] = useState({
    header: {
      text_color: "#000000",
      font_weight: 600,
    },
    collection_name: {
      text_color: "#000000",
      font_weight: 600,
    },
    collection_video: {
      autoplay: false,
    },
    aspect_ratio: "1:1",
  });
  const [plpConfig] = Form.useForm();

  //interactive states
  function generateUniqueId() {
    return Math.floor(100000 + Math.random() * 900000).toString();
  }

  const [interactiveData, setInteractiveData] = useState([
    {
      questionId: generateUniqueId(),
      questionName: null,
      originalQuestionId: null,
      parentQuestionId: null,
      feed_id: null,
      redirect_url: null,
      collapsed: false,
      loop: 0,
      subQuery: [],
    },
    {
      questionId: generateUniqueId(),
      originalQuestionId: null,
      parentQuestionId: null,
      questionName: null,
      feed_id: null,
      redirect_url: null,
      collapsed: false,
      loop: 0,
      subQuery: [],
    },
  ]);

  //pop up states
  const [fpqConfiguration, setFPQConfiguration] = useState({
    button_color: "#FF0000",
    text_color: "#FFFFFF",
    text: "Submit",
    video_layout: "1",
    show_sound_icon: true,
    heading_color: "#000000",
    desc_color: "#000000",
    submission_text_color: "#000000",
    continue_shopping_color: "#000000",
    continue_shopping_text_color: "#ffffff",
    continue_shopping_text: "Continue Shopping",
    show_header_background: false,
    show_description_background: false,
    header_background_color: "#ffffff",
    description_background_color: "#ffffff",
  });

  const [fpqConfig] = Form.useForm();

  const [vudioStoryConfiuration, setVudioStoryConfiguration] = useState({
    borderColor: {
      primaryColor: "#FF406C",
    },
    is_playback_image: true,
    name_color: "#000",
    font_weight: "600",
    cta_text_color: "#ffffff",
    cta_color: "#FF406C",
    cta_text: "Shop Now",
    font_style: "native",
    story_size: 100,
    gap: 15,
    padding: 5,
    video_title_view: true,
  });

  const [storyVideoConfigruation, setStoryVideoConfigruation] = useState({
    layout: "1",
    pip_screen: {
      display: true,
      location: "right",
    },
    email_embed: {
      display: true,
      location: "top-right",
    },
    is_video_mute: true,
    smv: {
      type: "smv1",
      display: true,
      showView: true,
      showShare: true,
      showMute: false,
      view_icon: "1",
    },

    discount: {
      display: true,
      style: {
        bg_color: "#ECD4D4",
        font_color: "#000000",
        font_weight: "400",
      },
      text: "discount",
    },

    actionable: {
      atc_shopify: {
        display: true,
        name: "Buy Now",
        style: {
          font_color: "#000000",
          font_style: "bold",
          bg_color: "#ECD4D4",
          font_weight: "400",
        },
        event: "atc",
        action_type: "button",
        layout: "checkout-shopping",
        actionable: {
          checkout: {
            display: true,
            action_type: "button",
            event: "checkout",
            name: "Add To Cart",
            style: {
              font_color: "#000000",
              font_style: "bold",
              bg_color: "#ECD4D4",
              font_weight: "400",
            },
          },
          shopping: {
            display: true,
            action_type: "button",
            event: "checkout",
            name: "Add To Cart",
            style: {
              font_color: "#000000",
              font_style: "bold",
              bg_color: "#ECD4D4",
              font_weight: "400",
            },
          },
        },
      },
      atc: {
        display: true,
        name: "Buy Now",
        style: {
          font_color: "#000000",
          font_style: "bold",
          bg_color: "#ECD4D4",
          font_weight: "400",
        },
        event: "pdp",
        action_type: "button",
      },
    },

    product: {
      display: true,
      product_layout: {
        layout_size: "L",
      },
      style: {
        bg_color: "#ECD4D4",
      },
      image: {
        display: true,
        type: "circle",
        style: {
          height: 32,
        },
      },
      name: {
        display: true,
        style: {
          font_color: "#000000",
          font_style: "normal",
          font_weight: "400",
        },
      },
      more_info: {
        display: true,
        event: "pdp",
      },
      price: {
        display: true,
        format: "integer",
        symbolText: "",
        prefix: true,
        original: {
          display: true,
          style: {
            font_color: "#000000",
            font_style: "normal",
            font_weight: "400",
          },
        },
        offer: {
          display: true,
          style: {
            font_color: "#000000",
            font_style: "normal",
            font_weight: "400",
          },
        },
        discount: {
          display: true,
          style: {
            font_color: "#000000",
            font_style: "normal",
            font_weight: "400",
          },
        },
      },
    },

    atc: {
      primary: {
        name: "Add To Cart",
        style: {
          font_weight: "400",
          font_color: "#000",
          bg_color: "#fff",
        },
      },
      secondary: {
        name: "More Info",
        style: {
          font_weight: "400",
          font_color: "#000",
          bg_color: "#fff",
        },
      },
    },

    glass_theme: false,

    glass_theme_atc: {
      primary: {
        text: "Add To Cart",
        style: {
          font_color: "#000000",
          font_weight: "400",
          bg_color: "#ffffff",
        },
      },
      secondary: {
        text: "Buy Now",
        style: {
          font_color: "#000000",
          font_weight: "400",
          bg_color: "#ffffff",
        },
      },
    },

    checkout_cta: {
      text: "Buy Now",
      style: {
        font_color: "#ffffff",
        bg_color: "#000000",
        font_weight: 500,
      },
    },
  });

  const resetCustomisationConfiguration = (widget_type) => {
    if (widget_type == "banner") {
      setBannerConfiguration({
        bannerRadius: 0,
        showMuteUnmute: true,
        ctaConfiguration: {
          display: true,
          text: "Shop Now",
          style: {
            fontColor: "#000000",
            fontWeight: 700,
            fontSize: 18,
            backgroundColor: "#000000",
            buttonColor: "#ffffff",
          },
        },
      });
    } else if (widget_type == "homepage-pip") {
      setPipHomepageCustomisation({
        redirect: "1",
        pipPlacement: "right",
        size: {
          desktop: {
            height: "230px",
            width: "130px",
          },
          mobile: {
            height: "150px",
            width: "90px",
          },
        },
      });
      setPipVideoCustomisation(video_configuration);
    } else if (widget_type == "stickyATC") {
      setAtcConfiguration({
        cta: {
          text: "Add to cart",
          backgroud_color: "#000000",
          text_color: "#ffffff",
          font_weight: 600,
        },
        product_name: {
          text_color: "#000000",
          font_weight: 600,
        },
        product_price: {
          selling_price: {
            text_color: "#000000",
            font_weight: 600,
          },
          original_price: {
            text_color: "#929292",
            font_weight: 600,
          },
          discount_tag: {
            text_color: "#ffffff",
            font_weight: 400,
            backgroud_color: "#00b528",
          },
          price_prefix: "INR",
        },
      });
    } else if (widget_type == "spotlight" || widget_type == "carousel") {
      setHomePageConfiguration(home_configuration);
      setVideoPageConfiguration(video_configuration);
    } else if (widget_type == "collection") {
      setPlpConfigurations({
        header: {
          text_color: "#000000",
          font_weight: 600,
        },
        collection_name: {
          text_color: "#000000",
          font_weight: 600,
        },
        collection_video: {
          autoplay: false,
        },
        aspect_ratio: "1:1",
      });
    } else if (widget_type == "interactive") {
      setInteractiveData([
        {
          questionId: generateUniqueId(),
          questionName: null,
          originalQuestionId: null,
          parentQuestionId: null,
          feed_id: null,
          redirect_url: null,
          collapsed: false,
          loop: 0,
          subQuery: [],
        },
        {
          questionId: generateUniqueId(),
          originalQuestionId: null,
          parentQuestionId: null,
          questionName: null,
          feed_id: null,
          redirect_url: null,
          collapsed: false,
          loop: 0,
          subQuery: [],
        },
      ]);
    } else if (widget_type == "popUp") {
      setFPQConfiguration({
        button_color: "#FF0000",
        text_color: "#FFFFFF",
        text: "Submit",
        video_layout: "1",
        show_sound_icon: true,
        heading_color: "#000000",
        desc_color: "#000000",
        submission_text_color: "#000000",
        continue_shopping_color: "#000000",
        continue_shopping_text_color: "#ffffff",
        continue_shopping_text: "Continue Shopping",
        show_header_background: false,
        show_description_background: false,
        header_background_color: "#ffffff",
        description_background_color: "#ffffff",
      });
    } else if (widget_type == "story") {
      setVudioStoryConfiguration({
        borderColor: {
          primaryColor: "#FF406C",
        },
        is_playback_image: true,
        name_color: "#000",
        font_weight: "600",
        cta_text_color: "#ffffff",
        cta_color: "#FF406C",
        cta_text: "Shop Now",
        font_style: "native",
        story_size: 100,
        gap: 15,
        padding: 5,
        video_title_view: true,
      });
      setStoryVideoConfigruation({
        layout: "1",
        pip_screen: {
          display: true,
          location: "right",
        },
        email_embed: {
          display: true,
          location: "top-right",
        },
        is_video_mute: true,
        smv: {
          type: "smv1",
          display: true,
          showView: true,
          showShare: true,
          showMute: false,
          view_icon: "1",
        },

        discount: {
          display: true,
          style: {
            bg_color: "#ECD4D4",
            font_color: "#000000",
            font_weight: "400",
          },
          text: "discount",
        },

        actionable: {
          atc_shopify: {
            display: true,
            name: "Buy Now",
            style: {
              font_color: "#000000",
              font_style: "bold",
              bg_color: "#ECD4D4",
              font_weight: "400",
            },
            event: "atc",
            action_type: "button",
            layout: "checkout-shopping",
            actionable: {
              checkout: {
                display: true,
                action_type: "button",
                event: "checkout",
                name: "Add To Cart",
                style: {
                  font_color: "#000000",
                  font_style: "bold",
                  bg_color: "#ECD4D4",
                  font_weight: "400",
                },
              },
              shopping: {
                display: true,
                action_type: "button",
                event: "checkout",
                name: "Add To Cart",
                style: {
                  font_color: "#000000",
                  font_style: "bold",
                  bg_color: "#ECD4D4",
                  font_weight: "400",
                },
              },
            },
          },
          atc: {
            display: true,
            name: "Buy Now",
            style: {
              font_color: "#000000",
              font_style: "bold",
              bg_color: "#ECD4D4",
              font_weight: "400",
            },
            event: "pdp",
            action_type: "button",
          },
        },

        product: {
          display: true,
          product_layout: {
            layout_size: "L",
          },
          style: {
            bg_color: "#ECD4D4",
          },
          image: {
            display: true,
            type: "circle",
            style: {
              height: 32,
            },
          },
          name: {
            display: true,
            style: {
              font_color: "#000000",
              font_style: "normal",
              font_weight: "400",
            },
          },
          more_info: {
            display: true,
            event: "pdp",
          },
          price: {
            display: true,
            format: "integer",
            symbolText: "",
            prefix: true,
            original: {
              display: true,
              style: {
                font_color: "#000000",
                font_style: "normal",
                font_weight: "400",
              },
            },
            offer: {
              display: true,
              style: {
                font_color: "#000000",
                font_style: "normal",
                font_weight: "400",
              },
            },
            discount: {
              display: true,
              style: {
                font_color: "#000000",
                font_style: "normal",
                font_weight: "400",
              },
            },
          },
        },

        atc: {
          primary: {
            name: "Add To Cart",
            style: {
              font_weight: "400",
              font_color: "#000",
              bg_color: "#fff",
            },
          },
          secondary: {
            name: "More Info",
            style: {
              font_weight: "400",
              font_color: "#000",
              bg_color: "#fff",
            },
          },
        },

        glass_theme: false,

        glass_theme_atc: {
          primary: {
            text: "Add To Cart",
            style: {
              font_color: "#000000",
              font_weight: "400",
              bg_color: "#ffffff",
            },
          },
          secondary: {
            text: "Buy Now",
            style: {
              font_color: "#000000",
              font_weight: "400",
              bg_color: "#ffffff",
            },
          },
        },

        checkout_cta: {
          text: "Buy Now",
          style: {
            font_color: "#ffffff",
            bg_color: "#000000",
            font_weight: 500,
          },
        },
      });
    }
  };

  const [isFirstTimeUser, setIsFirstTimeUser] = useState(false);

  const updateTutorialOverallProgress = async (moduleName, progress) => {
    if (userTutorialProgressDetails?._id) {
      try {
        const payload = {
          tutorial_id: userTutorialProgressDetails?._id,
          module: moduleName,
          progress: progress,
        };

        const response = ViewService.updateTutorialProgress(payload);
        if (response && progress == 100) {
          if (moduleName == "ai_video") {
            setTimeout(() => {
              LoadingService.hide();
              window.open("/app/dashboards/default", "_self");
            }, 1000);
          } else if (moduleName == "livestream") {
            setTimeout(() => {
              LoadingService.hide();
              window.open("/app/dashboards/default", "_self");
            }, 1000);
          } else if (moduleName == "social_media_post") {
            setTimeout(() => {
              LoadingService.hide();
              window.open("/app/dashboards/default", "_self");
            }, 1000);
          } else if (moduleName == "dm_automation") {
            setTimeout(() => {
              LoadingService.hide();
              window.open("/app/dashboards/default", "_self");
            }, 1000);
          }
        }
      } catch (err) {
      } finally {
        LoadingService.hide();
        return true;
      }
    }
  };

  const [currentParentFolderId, setCurrentParentFolderId] = useState(null);
  const [folders, setFolders] = useState([]);

  const fetchFolders = async (folderId) => {
    try {
      let requiredParams = {
        folder_id: folderId,
      };
      let response = await ViewService.getFolders(requiredParams);
      setFolders(response?.data || []);
    } catch (error) {
      console.log("Error in :: getFolders API", error);
    }
  };

  useEffect(() => {
    if (company.getCompanyId()) {
      resetContext();
    }
  }, [company.getCompanyId()]);

  return (
    <VudioContext.Provider
      value={{
        facebookConnectedAccounts,
        setFacebookConnectedAccounts,
        triggerData,
        setTriggerData,
        sidebarStep,
        setSidebarStep,
        triggerModal,
        setTriggerModal,
        selectedTriggerIndex,
        setSelectedTriggerIndex,
        responseSidebarStep,
        setResponseSidebarStep,
        quillRef,
        nodes,
        setNodes,
        edges,
        setEdges,
        removeNode,
        sidebarCondition,
        setSidebarCondition,
        logicSidebarStep,
        setLogicSidebarStep,
        triggerAddCondition,
        setTriggerAddCondtion,
        handleAddCondition,
        applyConditions,
        setApplyConditions,
        handleChange,
        nodesUpdatedTrigger,
        setNodesUpdatedTrigger,
        attachNodeById,
        generateNodeId,
        getPreviousNodeIdFromEdges,
        findNodeByID,
        selectedResponseID,
        setSelectedResponseID,
        selectedConditionID,
        setSelectedConditionID,
        selectedLogicNodeId,
        setSelectedLogicNodeID,
        selectedLogicYesNodeId,
        selectedLogicNoNodeId,
        setSelectedLogicYesNodeID,
        setSelectedLogicNoNodeID,
        isResponseOpen,
        setisResponseOpen,
        automationStep,
        setAutomationStep,
        handleLogicClick,
        handleContentClick,
        handleSelectRemoveNode,
        selectedStepNodeID,
        setSelectedStepNodeId,
        automationStepENUM,
        setAutomationStepENUM,
        templateID,
        setTemplateID,
        selectedAutomationTemplate,
        setSelectedAutomationTemplate,
        getPostAutomationId,
        getResponseMessage,
        setInstagramConnectedAccounts,
        instagramConnectedAccounts,
        isAddNodesModalOpen,
        setAddNodesModalOpen,
        handleDeleteNode,
        handleExit,
        fetchAutomationTemplates,
        atcConfiguration,
        setAtcConfiguration,
        pipHomepageCustomisation,
        setPipHomepageCustomisation,
        bannerConfiguration,
        setBannerConfiguration,
        homepageConfiguration,
        setHomePageConfiguration,
        resetCustomisationConfiguration,
        videoPageConfiguration,
        setVideoPageConfiguration,
        videoConfig,
        homepageConfig,
        showToast,
        setShowToast,
        toastCount,
        setToastCount,
        toastArray,
        setToastArray,
        handleToastData,
        handleToastArray,
        plpConfigurations,
        setPlpConfigurations,
        plpConfig,
        interactiveData,
        setInteractiveData,
        fpqConfiguration,
        setFPQConfiguration,
        fpqConfig,
        vudioStoryConfiuration,
        setVudioStoryConfiguration,
        storyVideoConfigruation,
        setStoryVideoConfigruation,
        pipVideoCustomisation,
        setPipVideoCustomisation,
        isFirstTimeUser,
        setIsFirstTimeUser,
        onboardingTutorial,
        setOnboardingTutorial,
        handleUpdateTutorialProgress,
        handleUpdateTutorialActiveState,
        updateTutorialOverallProgress,
        userTutorialProgressDetails,
        setUserTutorialProgressDetails,
        openDrawer,
        setOpenDrawer,
        resetContext,
        currentParentFolderId,
        setCurrentParentFolderId,
        folders,
        setFolders,
        fetchFolders,
        resetAllMasking,
        maskingCanvasRef,
        maskingContainerRef,
        maskingOverlayRef,
        maskingPaths,
        setMaskingPaths,
        maskingBrushSize,
        setMaskingBrushSize,
        resizeCanvasRef,
        resizeImageData, 
        setResizeImageData,
        resizeImage, 
        setResizeImage,
        resizeImageProps, 
        setResizeImageProps,
        resetAllResizeCanvas,
        userPermissions,
        setUserPermissions,
        userPermissions,
        setUserPermissions,
        isPermissionDetected, 
        setIsPermissionDetected
      }}
    >
      {children}
    </VudioContext.Provider>
  );
}

export default VudioProvider;
